<template>
  <div>
    <h1 class="show-in-mobile">Perfil</h1>
    <el-form :model="form" ref="form" :rules="rules" :label-width="formLabelWidth">
        <el-row>
          <el-col :xs="24" :md="8">
            <el-form-item label="Nueva Contraseña" prop="password">
              <el-input v-model="form.password" autocomplete="off" type="password" show-password></el-input>
            </el-form-item>
            <el-form-item label="Re-Contraseña" prop="re_password">
              <el-input v-model="form.re_password" autocomplete="off" type="password" show-password></el-input>
            </el-form-item>
            <div style="text-align:right">
            <el-button
              :loading="loadingSaveButton"
              type="primary"
              @click="handleSaveButton('form')"
              size="medium"
            >Guardar</el-button>
            </div>
          </el-col>
        </el-row>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase/app'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if( value === '' && this.form.password === '' ) {
        callback(new Error('Debe ingresar una contraseña'));
      } else if ( value !== this.form.password) {
        callback(new Error('Las dos contraseñas deben coincidir'));
      } else if ( value.length < 6 ) {
        callback(new Error('La contraseña debe tener al menos 6 letras'));
      } else {
        callback();
      }
    };
    return {
      loadingSaveButton: false,
      form: {},
      rules: {
        password: [
          { required: true, message: "Debe ingresar una contraseña", trigger: "blur"}
        ],
        re_password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
      },
      formLabelWidth: '160px'
    };
  },
  async created() {
    this.$store.commit("CHANGE_SECTION", { name: "Perfil", index: "-1" });

    // Load config
    await this.$store.dispatch("getConfig");
    this.form = this.$store.state.config
  },
  methods: {
    handleSaveButton(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          // Valid form
          this.loadingSaveButton = true

          var user = firebase.auth().currentUser;
          
          var prom = new Promise((resolve, reject) => { 
            user.updatePassword(this.form.re_password).then(function() {
              resolve()
            }).catch(function(error) {
              console.log(error)
              reject(error)
            })
          })
          .then( () => {
            this.$message({
              type: "success",
              message: 'El perfil fue actualizado'
            });
          })
          .catch( (error) => {
            let msg = ''
            if( error.code === 'auth/requires-recent-login' )
              msg = 'Sólo puede cambiar la contraseña cuando recién inicia sesión'
            else
              msg = 'Hubo un error actualizando el perfil'

            this.$message({
              type: "error",
              showClose: true,
              duration: 0,
              message: msg
            });
          })
          
          this.loadingSaveButton = false
        }
      })
    }
  },
  computed: {
    is_mobile() {
      return this.$store.state.is_mobile;
    },
  }
};
</script>